import React from "react";
import { RepassesSetoriaisProvider } from "./context/repasses-setoriais-context";
import { RepassesSetoriais } from "./repasses-setoriais";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const RepassesSetoriaisFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Repasses Setoriais"}>
            <RepassesSetoriaisProvider>
                <RepassesSetoriais />
            </RepassesSetoriaisProvider>
        </BaseInternalFormFactory>
    );
};

export default RepassesSetoriaisFactory;
